// Fallback value for session summary is a user generates a summary but then deletes it. Intended behaviour is that a user cannot delete a summary / remove the summary line.
export const SESSION_SUMMARY_FALL_BACK = 'No summary';

// Placeholder the backend seeds `session_gist` with before a note exists. The
// real AI summary only lands once the session has been transcribed, so summary
// surfaces gate their visibility on the gist not being this value.
export const UNKNOWN_SESSION_GIST = 'Unknown Session';

/**
 * The gist a session display-name fallback may show, or `undefined` when the
 * gist is one of the backend's placeholders.
 *
 * Both placeholders are backend bookkeeping, not titles: `No summary` for a
 * deleted summary, `Unknown Session` for one that has not been generated yet.
 * Showing either as a session title reads to a clinician as the session's real
 * name, so a name chain falls through to its untitled label instead. Kept here,
 * next to the constants, so a third placeholder is added in one place rather
 * than in every chain that has to exclude it.
 *
 * Trimmed before it is judged, and the trimmed value is what's returned. A gist
 * of only whitespace is truthy, so an untrimmed check would hand a name chain a
 * blank string it renders as the session's title — a nameless row rather than
 * the untitled label, which is the same defect the placeholders are excluded to
 * avoid.
 */
export const getDisplayableSessionGist = (
  gist: string | null | undefined
): string | undefined => {
  const trimmed = gist?.trim();
  return trimmed &&
    trimmed !== SESSION_SUMMARY_FALL_BACK &&
    trimmed !== UNKNOWN_SESSION_GIST
    ? trimmed
    : undefined;
};
